{
  "it": {
    "sublines": {
      "hangarGuide": {
        "headline": "forse dovremmo cambiare questo ;)",
        "add": "Come aggiungere una nave?",
        "edit": "Come modificare una nave?",
        "wishlist": "Come aggiungere una nave alla lista dei desideri?",
        "fleetchart": "Grafico flotta?",
        "public": "URL Pubblico?",
        "groups": "Come creare e aggiornare i gruppi?"
      },
      "impressum": {
        "general": "Informazioni generali (ai sensi del § 5 TMG)",
        "disclaimer": "Disclaimer",
        "copyright": "Copyright",
        "thirdpartycontent": "Crediti",
        "sponsors": "Sponsor",
        "liabilityInternal": "Limitazione della responsabilità per il contenuto interno",
        "liabilityExternal": "Limitazione della responsabilità per i collegamenti esterni"
      },
      "settings": {
        "rsiData": "Informazioni RSI"
      }
    }
  }
}
